import React, { FC } from 'react';
import { Select } from '@kontentino/ui';
import { useQuery } from 'react-query';
import PageApi from 'api/page';
import { queryKey } from 'constants/queryKey';

type Props = {
  pageId: number;
  value: number | null;
  onChange: (project: number | null) => void;
  disabled?: boolean;
};

const PostComposerPlanningContentPlanSelect: FC<Props> = ({
  pageId,
  disabled,
  onChange,
  value,
}) => {
  const { data, isLoading } = useQuery(
    queryKey.pageDetail(pageId),
    () => PageApi.detail(pageId as number),
    {
      onSuccess({ projects }) {
        const preselectedProject =
          projects.find((project) => project.name === 'Default') || projects[0];

        if (!value && preselectedProject) {
          onChange(preselectedProject.id ?? null);
        }
      },
    },
  );

  function getOptions() {
    return (
      data?.projects.map((project) => ({
        label: project.name,
        value: project.id,
      })) ?? []
    );
  }

  function getValue() {
    if (!value) return null;

    return getOptions().find((option) => option.value === value) ?? null;
  }

  return (
    <Select
      isLoading={isLoading}
      isDisabled={disabled}
      data-cy="post-form-content-plan-select"
      options={getOptions()}
      value={getValue()}
      onChange={(option) => onChange?.(option?.value ?? null)}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (styles) => ({
          ...styles,
          zIndex: 1010,
        }),
      }}
    />
  );
};
export default PostComposerPlanningContentPlanSelect;
